import { Type } from "class-transformer";
import { IsInt, IsOptional, IsString } from 'class-validator';

export class InvoiceBillingFiltersDto {
  @IsOptional()
  @IsInt()
  @Type(() => Number)
  pieMerchantBusinessEntityId?: number;

  @IsOptional()
  @IsInt()
  @Type(() => Number)
  invoiceStatusId?: number;

  @IsOptional()
  @IsString()
  billingStartDate?: string;
}